module.exports = ".kan-partner-type-dialog-container {\n  font-size: 13px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/dialogs/partner-type-dialog/component.scss
// module id = ./src/modules/admin/dialogs/partner-type-dialog/component.scss
// module chunks = main